/* eslint-disable camelcase */
import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import { Box, Grid, Button, Typography, CircularProgress } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"

import Header from "../../layouts/Header"
// SOLUCIÓN 1: Importamos el botón de regresar nativo de la arquitectura
import BackIcon from "../../components/BackIcon"
import { api } from "../../api"

// Componentes Hijos
import HeaderContexto from "./components/HeaderContexto"
import ChecklistBotones from "./components/ChecklistBotones"
import TimelineBitacora from "./components/TimelineBitacora"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const CRM_Workspace = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const id = location.state?.car_id

  // Consulta Maestra del Expediente
  const {
    data: response,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["getCarpetaWorkspace", id],
    queryFn: async () => {
      const res = await api.post("/CRM_Carpetas/getCarpetaWorkspace", { car_id: id })
      return res.data
    },
    // Solo ejecuta la consulta si existe un ID
    enabled: !!id,
  })

  const workspaceData = response?.data || {}
  const { contexto, etapa_actual, historial } = workspaceData

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress color="primary" />
      </Box>
    )
  }

  // Si alguien entra directamente a la URL sin pasar por la bandeja, no habrá ID
  if (isError || !contexto || !id) {
    return (
      <Box p={3} textAlign="center" mt={10}>
        <Typography color="error" variant="h6">
          {!id
            ? "Acceso inválido. Seleccione un expediente desde la bandeja."
            : "Error al cargar el expediente o no existe."}
        </Typography>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/home/dashboard/CRM_Bandejas")}
          sx={{ mt: 2 }}
        >
          Volver a Bandejas
        </Button>
      </Box>
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      {/* SOLUCIÓN 2: Envolvemos en el div "main main-app" para respetar los márgenes del menú y header */}
      <div className="main main-app p-3 p-lg-4" style={{ backgroundColor: "#f0f2f5", minHeight: "100vh" }}>
        {/* Implementación del BackIcon estándar */}
        <BackIcon />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 20px 30px",
            fontSize: "25px",
          }}
        >
          <b>Expediente Comercial: {contexto.car_id}</b>
        </div>

        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {/* Fila 1: Cabecera completa */}
            <Grid item xs={12}>
              <HeaderContexto contexto={contexto} etapa={etapa_actual} />
            </Grid>

            {/* Fila 2: Izquierda (Checklist) y Derecha (Timeline) */}
            <Grid item xs={12} md={4}>
              <ChecklistBotones etapa={etapa_actual} car_id={contexto.car_id} status={contexto.car_status} />
            </Grid>

            <Grid item xs={12} md={8}>
              <TimelineBitacora historial={historial} />
            </Grid>
          </Grid>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default CRM_Workspace
